
export const MONTH_NAMES_PT = [
	'Janeiro',
	'Fevereiro',
	'Março',
	'Abril',
	'Maio',
	'Junho',
	'Julho',
	'Agosto',
	'Setembro',
	'Outubro',
	'Novembro',
	'Dezembro',
];

export const MONTH_ABBR_PT = [
	'Jan',
	'Fev',
	'Mar',
	'Abr',
	'Mai',
	'Jun',
	'Jul',
	'Ago',
	'Set',
	'Out',
	'Nov',
	'Dez',
];

export const formatDateFromISO = (dateStr: string): string => {
	if (!dateStr) return '—';

	const [date] = dateStr.split('T');
	const [year, month, day] = date.split('-');

	if (!year || !month || !day) return dateStr;

	return `${day}/${month}/${year}`;
};

export const formatDate = (date: Date): string => {
	const d = String(date.getDate()).padStart(2, '0');
	const m = String(date.getMonth() + 1).padStart(2, '0');
	const y = date.getFullYear();
	return `${d}/${m}/${y}`;
};

export const formatDateISO = (date: Date): string => {
	const y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, '0');
	const d = String(date.getDate()).padStart(2, '0');
	return `${y}-${m}-${d}`;
};

export const parseDateISO = (value: string): Date | null => {
	const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
	if (!match) return null;
	const [, year, month, day] = match;
	return new Date(Number(year), Number(month) - 1, Number(day));
};

export const parseDateBR = (value: string): Date | null => {
	const match = /^(\d{2})\/(\d{2})\/(\d{4})/.exec(value);
	if (!match) return null;
	const [, day, month, year] = match;
	return new Date(Number(year), Number(month) - 1, Number(day));
};

export const parseDateISOOrBR = (value: string): Date | null => {
	const isoMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
	if (isoMatch) {
		const [, year, month, day] = isoMatch;
		return new Date(Number(year), Number(month) - 1, Number(day));
	}

	return parseDateBR(value);
};

export const isWithinDateRange = (value: string, startDate?: string, endDate?: string): boolean => {
	if (!startDate && !endDate) return true;

	const date = parseDateISOOrBR(value);
	if (!date) return false;

	const start = startDate ? parseDateISO(startDate) : null;
	const end = endDate ? parseDateISO(endDate) : null;

	if (start) start.setHours(0, 0, 0, 0);
	if (end) end.setHours(23, 59, 59, 999);

	if (start && date < start) return false;
	if (end && date > end) return false;
	return true;
};

export const buildPeriodQueryRange = (
	periodFilters: string[],
	customDateFrom: string,
	customDateTo: string
): { startDate?: string; endDate?: string } => {
	let from: Date | null = null;
	let to: Date | null = null;

	for (const period of periodFilters) {
		if (period === '15' || period === '30') {
			const days = Number.parseInt(period, 10);
			const periodTo = new Date();
			const periodFrom = new Date();
			periodFrom.setDate(periodFrom.getDate() - (days - 1));
			if (!from || periodFrom < from) from = periodFrom;
			if (!to || periodTo > to) to = periodTo;
		}

		if (period === 'custom') {
			const customFrom = customDateFrom ? parseDateISO(customDateFrom) : null;
			const customTo = customDateTo ? parseDateISO(customDateTo) : null;
			if (customFrom && (!from || customFrom < from)) from = customFrom;
			if (customTo && (!to || customTo > to)) to = customTo;
		}
	}

	return {
		startDate: from ? formatDateISO(from) : undefined,
		endDate: to ? formatDateISO(to) : undefined,
	};
};

export const formatTimeFromISO = (iso?: string): string => {
	if (!iso) return '—';
	const d = new Date(iso);
	if (isNaN(d.getTime())) return '—';
	return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
};

export const timeAgo = (date: Date): string => {
	const diffMs = Date.now() - date.getTime();
	const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
	if (diffDays === 0) return 'Hoje';
	if (diffDays === 1) return 'Faz 1 dia';
	return `Faz ${diffDays} dias`;
};
